module.exports = __webpack_public_path__ + "img/1-low.5bd02040.jpg";